import { CacheHandler } from "reusable/utils/cache";

export const authCache = {
   rememberMe: new CacheHandler<boolean>({ key: 'GapAppLocalAuthRememberMe', cacheLocation: 'localStorage' }),
   showStaySignedIn: new CacheHandler<boolean>({ key: 'GapAppLocalAuthShowStaySignedIn', cacheLocation: 'localStorage' }),
   signedInWithXero: new CacheHandler<true>({ key: 'auth:signed-in-with-xero', cacheLocation: 'sessionStorage' }),
   inviteeEmail: new CacheHandler<string>({ key: 'auth:invitee-email', cacheLocation: 'localStorage' }),
}
